// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-card {\n  margin: 20px;\n}\n.product-card .flex {\n  position: relative;\n}\n.product-card .flex .icon {\n  color: white;\n  font-size: 45pt;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n}\n.product-card .flex .icon-montatura {\n  font-size: 68px;\n}\n.product-card .flex .icon-coppia-aste {\n  font-size: 46px;\n}\n", ""]);
// Exports
module.exports = exports;
